import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { jobsApi } from "../../lib/api";
import HistoryTab, { getWeekBounds } from "../../components/mobile/HistoryTab";

/**
 * Mobile Job History — the `/history` route on small viewports. Reuses the
 * same HistoryTab component MobileHome's History tab uses, scoped to every
 * job in the company (admin/dispatcher/office_personnel only route).
 */
export default function MobileJobHistory() {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [from, setFrom] = useState(() => getWeekBounds(new Date()).startStr);
  const [to, setTo] = useState(() => getWeekBounds(new Date()).endStr);

  useEffect(() => {
    jobsApi.list()
      .then((j) => setJobs(j || []))
      .catch(() => toast.error("Could not load job history"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      className="mv md:hidden min-h-screen w-full"
      style={{
        paddingTop: "calc(3.5rem + env(safe-area-inset-top))",
        paddingBottom: "calc(5rem + env(safe-area-inset-bottom))",
      }}
      data-testid="mobile-job-history"
    >
      {loading ? (
        <div className="p-10 text-center text-slate-400 text-sm">Loading…</div>
      ) : (
        <HistoryTab
          jobs={jobs}
          from={from}
          to={to}
          onFromChange={setFrom}
          onToChange={setTo}
          onOpenJob={(id) => navigate(`/mobile/jobs/${id}`)}
        />
      )}
    </div>
  );
}
